var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionDraftEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6662H17.5M2.50002 16.6662H3.89547C4.30312 16.6662 4.50695 16.6662 4.69876 16.6202C4.86882 16.5793 5.0314 16.512 5.18052 16.4206C5.34871 16.3175 5.49284 16.1734 5.78109 15.8852L16.25 5.4162C16.9404 4.72585 16.9404 3.60656 16.25 2.9162C15.5597 2.22585 14.4404 2.22585 13.75 2.9162L3.28107 13.3852C2.99282 13.6734 2.84869 13.8175 2.74562 13.9857C2.65424 14.1349 2.5869 14.2974 2.54607 14.4675C2.50002 14.6593 2.50002 14.8631 2.50002 15.2708V16.6662Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDraftEmail);
export default __webpack_public_path__ + "static/media/action-draft-email.49bee5bd0094b80d2361c00aeb937181.svg";
export { ForwardRef as ReactComponent };